import * as yup from "yup";

export const initialValues = {
  country: "",
  benefitType: null,
  benefitValue: null,
};

export const schema = yup.object().shape({
  country: yup.string().required("Please select a country."),
  benefitType: yup.string().required("Please select a benefit type."),
  benefitValue: yup.string().required("Please enter a benefit value."),
});
